import { render, staticRenderFns } from "./RegistroForm.vue?vue&type=template&id=5343e5d4"
import script from "./RegistroForm.vue?vue&type=script&lang=js"
export * from "./RegistroForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports